export default (eventName, data) => {
  /* eslint-disable no-underscore-dangle */
  window._hsq = window._hsq || [];
  window._hsq.push([eventName, data]);
  /* eslint-enable no-underscore-dangle */
};
